import { Component, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

type SelectorItem = {
  icon: string;
  text: string;
};

@Component({
  selector: 'app-customer-detail-selector',
  templateUrl: './customer-detail-selector.component.html',
  styleUrls: ['./customer-detail-selector.component.scss'],
})

/**
 * Shows options for customer details
 */
export class CustomerDetailSelectorComponent {
  selectorItems: SelectorItem[] = [
    {
      icon: 'show_chart',
      text: 'summary',
    },
    {
      icon: 'stars',
      text: 'points',
    },
    {
      icon: 'print',
      text: 'products',
    },
    {
      icon: 'redeem',
      text: 'coupons',
    },
  ];
  @Output() selectedItem = new EventEmitter<any>();

  /**
   * @constructor
   */
  constructor(private router: Router, private route: ActivatedRoute) {}

  /**
   * open child component
   * @param {string} item
   */
  showContent(item: string) {
    this.selectedItem.emit(item);
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: { detail: item },
    });
  }

  /**
   * Check active button
   * @param {string} item
   * @return {boolean}
   */
  isActive(item: string) {
    return item === this.route.snapshot.queryParamMap.get('detail');
  }
}
